import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const TextField = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  helper,
  leftIcon,
  rightIcon,
  type = 'text',
  disabled = false,
  className = ''
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className={`${className}`}>
      {label && (
        <label className="block text-sm font-medium text-[#0C1D40] mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
            {leftIcon}
          </div>
        )}
        <input
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`
            w-full px-6 py-3 
            ${leftIcon ? 'pl-12' : ''}
            ${rightIcon || isPassword ? 'pr-12' : ''}
            bg-[#F9F9F9] 
            border-2 border-[#E6E6E6]
            rounded-2xl
            outline-none
            focus:border-pink-300
            transition-colors
            text-[#0C1D40]
            placeholder-gray-400
            disabled:opacity-50
            ${error ? 'border-red-500' : ''}
          `}
          aria-invalid={!!error}
          aria-describedby={error ? `${label}-error` : undefined}
        />
        {isPassword ? (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        ) : rightIcon ? (
          <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400">
            {rightIcon}
          </div>
        ) : null}
      </div>
      {error && (
        <p id={`${label}-error`} className="mt-2 text-sm text-red-500">
          {error}
        </p>
      )}
      {helper && !error && (
        <p className="mt-2 text-sm text-gray-500">
          {helper}
        </p>
      )}
    </div>
  );
};

export default TextField;